import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

function minPtBR(min: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const n = parsePtBRToNumber(control.value);
    if (n === null) return { invalidCurrency: true }; // não parseou
    return n >= min ? null : { minPtBR: { requiredMin: min, actual: n } };
  };
}

// Helper compatível com Angular 5 para marcar todos os controles como touched
function markAllControlsAsTouched(control: AbstractControl): void {
  if (control instanceof FormGroup) {
    const controlsObj = (control as FormGroup).controls;
    const keys = Object.keys(controlsObj);
    for (let i = 0; i < keys.length; i++) {
      markAllControlsAsTouched(controlsObj[keys[i]]);
    }
  } else if (control instanceof FormArray) {
    const arr = control as FormArray;
    for (let i = 0; i < arr.length; i++) {
      markAllControlsAsTouched(arr.at(i));
    }
  }
  control.markAsTouched();
  control.updateValueAndValidity({ onlySelf: true, emitEvent: false });
}
function parsePtBRToNumber(v: string | number | null | undefined): number | null {
  if (v === null || v === undefined) return null;
  if (typeof v === 'number') return isFinite(v) ? v : null;

  let s = v.trim();
  if (!s) return null;

  s = s
    .replace(/[^\d.,-]/g, '')  // remove R$, espaços etc
    .replace(/\./g, '')        // remove separador de milhar
    .replace(',', '.');        // troca decimal

  const n = Number(s);
  return isNaN(n) ? null : n;
}




@Component({
  selector: 'sarf-detalhe-valor-mensal-distribuir',
  templateUrl: './detalhe-valor-mensal-distribuir.component.html'
})
export class DetalheValorMensalDistribuirComponent  implements OnInit {

  @Input() mesanoSelecionado: any; 
  @Output() onConfirm = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<number>();
   
  constructor(protected readonly fb: FormBuilder) {}

  ngOnInit() {
    this.atualizarFormulario();
  }


  formDetalhe = new FormGroup({
    mesReferencia: new FormControl({value: '', disabled: true}, Validators.required),
    valorDistribuido: new FormControl('', [Validators.required, minPtBR(0.01)]),
  });
 
  atualizarFormulario() {
    this.atualizarControle('mesReferencia', this.mesanoSelecionado.DataReferenciaDistribuicaoFormatada);
    
    // valor vindo do banco (pode ser string "100000.02" ou número 100000.02)
    const bruto = this.mesanoSelecionado.ValorMensalDistribuicao;

    // 1) Garanta que é número
    const valorNum = typeof bruto === 'number' ? bruto : Number(bruto);

    // 2) Formate em pt-BR com 2 casas
    const valorFormatado = valorNum.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    this.atualizarControle('valorDistribuido', valorFormatado);
  }

 /*
  * Atualiza o conteúdo do controle verificando a nulidade do futuro conteúdo.
  */
  atualizarControle(controle: string, value: any) {
    this.formDetalhe.get(controle).setValue(value === null || value === undefined ? '-' : value.toString());
  }

   private buildPayload(): any {
    const raw = this.formDetalhe.getRawValue(); // inclui desabilitados
    // Normaliza valorDistribuido

    const valorDistribuidoNumber =  raw.valorDistribuido == null  ? null : (typeof raw.valorDistribuido === 'number' ? raw.valorDistribuido : parsePtBRToNumber(String(raw.valorDistribuido)));
    debugger
    // Pega id com fallback
    var SequencialValorMensalDistribuicao = null;
    if (this.mesanoSelecionado) {
      if (this.mesanoSelecionado.SequencialValorMensalDistribuicao != null) {
        SequencialValorMensalDistribuicao = this.mesanoSelecionado.SequencialValorMensalDistribuicao;
      } else if (this.mesanoSelecionado.SequencialValorMensalDistribuicao != null) {
        SequencialValorMensalDistribuicao = this.mesanoSelecionado.SequencialValorMensalDistribuicao;
      }
    }

    const mesReferencia = (raw && raw.mesReferencia != null) ? raw.mesReferencia : '';

    return {
      SequencialValorMensalDistribuicao: SequencialValorMensalDistribuicao,
      mesReferencia: mesReferencia,
      valorMensalDistribuicao: valorDistribuidoNumber
    };
  }

  fechar(){
    this.onClose.emit(2);
  }
  confirmar() {
    markAllControlsAsTouched(this.formDetalhe);
    if (this.formDetalhe.invalid) return;

    const payload = this.buildPayload();
    this.onConfirm.emit(payload);
  }

}



// WEBPACK FOOTER //
// ./src/app/royalts/valor-mensal-distribuir/detalhe-valor-mensal-distribuir/detalhe-valor-mensal-distribuir.component.ts